// extracted by mini-css-extract-plugin
module.exports = {"taskAssign":"taskAssign_taskAssign__3bynU"};